<template>
  <div class="list-bg">
    <div class="content" @click="onClickItem">
      <div class="mark-point" :class="{active: itemObj.scene_id === currentScenesId}"></div>
      <span class="type" v-if="itemObj.type">{{listType[itemObj.type]}}</span>
      <span class="list-name">{{itemObj.scene_title}}</span>

      <a-dropdown>
        <a-menu slot="overlay" @click="handleMenuClick">
          <a-menu-item key="1">{{$t('actionTitles.rename')}}</a-menu-item>
          <a-menu-item key="2">{{$t('actionTitles.delete')}}</a-menu-item>
        </a-menu>
        <a-button>
          {{$t('edit.options')}}
          <a-icon type="down" />
        </a-button>
      </a-dropdown>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
export default {
  props: {
    itemObj: {
      required: true,
      type: Object,
    },
  },
  computed: { ...mapGetters(["currentScenesId"]) },
  data() {
    return {
      listType: {
        word: "T",
        pictext: this.$t('edit.typeList.picture'),
        pic: this.$t('edit.typeList.picture'),
        video: this.$t('edit.typeList.video'),
        audio: this.$t('edit.typeList.audio'),
        link: this.$t('edit.typeList.link'),
        scene: this.$t('edit.typeList.scene'),
      },
    };
  },
  methods: {
    handleMenuClick({ item, key }) {
      if (key === "1") {
        this.$emit("renameItem", this.itemObj);
      } else if (key === "2") {
        this.$emit("deleteItem", this.itemObj);
      }
    },
    onClickItem() {
      this.$emit("onSelectItem", this.itemObj)
    }
  },
};
</script>

<style lang="less" scoped>
.list-bg {
  .content {
    .mark-point {
      width: 10px;
      height: 10px;
      border-radius: 50%;
      background-color: #5f5f5f;
      margin-right: 10px;
    }
    .active {
      background-color: #ff6600;
    }
  }
  .content:hover {
    border: 2px solid #1890ff;;
  }
}
</style>